import { FormValidationSchema } from "@/components/Form/types";
import { getRuleErrorMessage } from "@/utils/formHelper";
import { EMAIL_PATTERN } from "./patterns";

export const contactUsValidation = (data: any): FormValidationSchema[] => [
  {
    name: "email",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("email", "required", data),
      },
      pattern: {
        value: EMAIL_PATTERN,
        message: getRuleErrorMessage("email", "pattern", data),
      },
    },
  },
  {
    name: "query",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("query", "required", data),
      },
    },
  },
  {
    name: "subject",
    rules: {
      required: {
        value: true,
        message: getRuleErrorMessage("subject", "required", data),
      },
    },
  },
];
